import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { BACKEND_URL } from '../../../../util/api'

const iframeStyle = {
    width: '100%',
    height: '1000px',
}

const InvoiceCorrectionResult = ({ invoiceCorrection }) => {
    const viewLink = BACKEND_URL + '/api/invoice/pdf/view?fileId=' + invoiceCorrection.fileId

    return (
        <ContentBox title={'Invoice Correction ' + invoiceCorrection.referenceNumber}>
            <Row>
                <Column size={12}>
                    <iframe src={viewLink} title="Invoice Correction" style={iframeStyle}/>
                </Column>
            </Row>
        </ContentBox>
    )
}


InvoiceCorrectionResult.propTypes = {
    invoiceCorrection: PropTypes.object.isRequired,
}


export default InvoiceCorrectionResult




// WEBPACK FOOTER //
// ./src/modules/invoice/component/correction/InvoiceCorrectionResult.js